export default {
  值: '值',
  其他: '其他',
  规则: '规则',
  添加: '添加',
  时间: '时间',
  新建: '新建',
  编辑: '编辑',
  删除: '删除',
  保存: '保存',
  取消: '取消',
  确定: '确定',
  关闭: '关闭',
  搜索: '搜索',
  刷新: '刷新',
  更多: '更多',
  关联: '关联',
  评论: '评论',
  法人: '法人',
  省份: '省份',
  公司: '公司',
  律所: '律所',
  序号: '序号',
  已选: '已选',
  读写: '读写',
  只读: '只读',
  姓名: '姓名',
  权限: '权限',
  回复: '回复',
  对象: '对象',
  作废: '作废',
  筛选: '筛选',
  清除: '清除',
  重复: '重复',
  群名称: '群名称',
  群成员: '群成员',
  基金会: '基金会',
  新机构: '新机构',
  未生效: '未生效',
  已生效: '已生效',
  已接通: '已接通',
  未接通: '未接通',
  创建人: '创建人',
  已结束: '已结束',
  负责人: '负责人',
  协作人: '协作人',
  注册号: '注册号',
  拨打人: '拨打人',
  转化人: '转化人',
  联系人: '联系人',
  接收人: '接收人',
  请修改: '请修改',
  列选择: '列选择',
  日程主题: '日程主题',
  转化时间: '转化时间',
  转移原因: '转移原因',
  文件名称: '文件名称',
  来源模块: '来源模块',
  文件类型: '文件类型',
  事业单位: '事业单位',
  社区组织: '社区组织',
  详情附件: '详情附件',
  香港公司: '香港公司',
  机构类型: '机构类型',
  注册资金: '注册资金',
  注册资本: '注册资本',
  成立日期: '成立日期',
  是否KDM: '是否KDM',
  联系电话: '联系电话',
  群组名称: '群组名称',
  妙记链接: '妙记链接',
  新建日程: '新建日程',
  会议妙记: '会议妙记',
  编辑日程: '编辑日程',
  添加跟进: '添加跟进',
  取消评论: '取消评论',
  上传附件: '上传附件',
  本地附件: '本地附件',
  附件类型: '附件类型',
  支持上传: '支持上传',
  等格式的文件: '等格式的文件',
  格式的文件: '格式的文件',
  复制成功: '复制成功',
  删除成功: '删除成功',
  编辑跟进: '编辑跟进',
  新增成功: '新增成功',
  确认删除: '确认删除',
  创建群组: '创建群组',
  创建失败: '创建失败',
  创建成功: '创建成功',
  添加成功: '添加成功',
  添加失败: '添加失败',
  拨打时间: '拨打时间',
  应答时间: '应答时间',
  结束时间: '结束时间',
  通话时长: '通话时长',
  跟进建议: '跟进建议',
  跟进详情: '跟进详情',
  线索渠道: '线索渠道',
  成交状态: '成交状态',
  客户名称: '客户名称',
  全部数据: '全部数据',
  提示信息: '提示信息',
  插入变量: '插入变量',
  查重条件: '查重条件',
  精准匹配: '精准匹配',
  模糊匹配: '模糊匹配',
  更新成功: '更新成功',
  更新失败: '更新失败',
  基础字段: '基础字段',
  当前默认: '当前默认',
  设为默认: '设为默认',
  恢复默认: '恢复默认',
  拖到这里: '拖到这里',
  类型的筛选: '类型的筛选',
  值不能为空: '值不能为空',
  我方参会人: '我方参会人',
  客户参会人: '客户参会人',
  业绩参与人: '业绩参与人',
  线索跟进人: '线索跟进人',
  添加联系人: '添加联系人',
  新增云文档: '新增云文档',
  联系人职位: '联系人职位',
  新增联系人: '新增联系人',
  编辑联系人: '编辑联系人',
  联系人拨打: '联系人拨打',
  已完成日程: '已完成日程',
  未完成日程: '未完成日程',
  未发现客户: '未发现客户',
  数据加载中: '数据加载中',
  管理协作人: '管理协作人',
  新增协作人: '新增协作人',
  数据保存中: '数据保存中',
  云文档链接: '云文档链接',
  云文档类型: '云文档类型',
  已添加的列: '已添加的列',
  可选择的列: '可选择的列',
  老板委派调研人: '老板委派调研人',
  组织机构代码: '组织机构代码',
  暂无沟通记录: '暂无沟通记录',
  创建群组失败: '创建群组失败',
  关联客户信息: '关联客户信息',
  获取数据失败: '获取数据失败',
  添加动态记录: '添加动态记录',
  暂无通话记录: '暂无通话记录',
  编辑动态记录: '编辑动态记录',
  下次跟进时间: '下次跟进时间',
  下次跟进方式: '下次跟进方式',
  下次参会人员: '下次参会人员',
  请选择下次参会人员: '请选择下次参会人员',
  单次上传最多支持: '单次上传最多支持',
  个文件: '个文件',
  文件类型无限制: '文件类型无限制',
  字段同步: '字段同步',
  新增协作人失败: '新增协作人失败',
  编辑协作人失败: '编辑协作人失败',
  协作人查询异常: '协作人查询异常',
  已添加动态记录: '已添加动态记录',
  暂无已完成日程: '暂无已完成日程',
  请选择是否KDM: '请选择是否KDM',
  设为默认联系人: '设为默认联系人',
  请输入评论内容: '请输入评论内容',
  联系人所在部门: '联系人所在部门',
  请选择抬头类型: '请选择抬头类型',
  请输入开票抬头: '请输入开票抬头',
  请输入纳税识别号: '请输入纳税识别号',
  请选择参与人角色: '请选择参与人角色',
  请选择协作阶段: '请选择协作阶段',
  请输入绩效比例: '请输入绩效比例',
  请选择附件类型: '请选择附件类型',
  请上传本地附件: '请上传本地附件',
  请输入云文档链接: '请输入云文档链接',
  请选择云文档类型: '请选择云文档类型',
  请输入正确的手机号: '请输入正确的手机号',
  请输入员工手机号: '请输入员工手机号',
  请选择外呼中间号: '请选择外呼中间号',
  请查找或选择号码: '请查找或选择号码',
  请选择默认号码: '请选择默认号码',
  请选择部门和人员: '请选择部门和人员',
  请填写手机号: '请填写手机号',
  搜索员工姓名: '搜索员工姓名',
  请输入提示信息: '请输入提示信息',
  筛选数据不完整: '筛选数据不完整',
  请输入选项名称: '请输入选项名称',
  请输入选项值: '请输入选项值',
  字段类型为必选项: '字段类型为必选项',
  请选择字段类型: '请选择字段类型',
  选项数据名称: '选项数据名称',
  选项选项值: '选项选项值',
  设置选项为必填项: '设置选项为必填项',
  选项key值为必填项: '选项key值为必填项',
  转化为客户商机: '转化为客户商机',
  请填写评论内容: '请填写评论内容',
  动态记录: '动态记录',
  请输入群名称: '请输入群名称',
  请输入备注: '请输入备注',
  会议状态: '会议状态',
  请输入key值: '请输入key值',
  我的外呼设置: '我的外呼设置',
  外呼设置: '外呼设置',
  外呼系统工号: '外呼系统工号',
  外呼系统角色: '外呼系统角色',
  外呼拨打号码: '外呼拨打号码',
  请输入详细地址: '请输入详细地址',
  请选择地址类型: '请选择地址类型',
  请输入邮政编码: '请输入邮政编码',
  请输入字段名称: '请输入字段名称',
  请输入数据条件: '请输入数据条件',
  请选择视图: '请选择视图',
  请选择视图类型: '请选择视图类型',
  请选择日期范围: '请选择日期范围',
  请填写规则名称: '请填写规则名称',
  请选择数据对象: '请选择数据对象',
  请输入开户银行: '请输入开户银行',
  请输入开户账号: '请输入开户账号',
  请输入开票地址: '请输入开票地址',
  请输入部门名称: '请输入部门名称',
  请输入姓名搜索: '请输入姓名搜索',
  请输入规则名称: '请输入规则名称',
  请填写跟进详情: '请填写跟进详情',
  请选择协作人: '请选择协作人',
  请输入一级选项名称: '请输入一级选项名称',
  请输入二级选项名称: '请输入二级选项名称',
  请输入三级选项名称: '请输入三级选项名称',
  审批中的订单不可作废: '审批中的订单不可作废',
  审批中的报价单不可作废: '审批中的报价单不可作废',
  请输入新建的角色名: '请输入新建的角色名',
  请输入修改的角色名: '请输入修改的角色名',
  跟进详情是必填项: '跟进详情是必填项',
  请填写联系人姓名: '请填写联系人姓名',
  请选择联系人职位: '请选择联系人职位',
  统一社会信用代码: '统一社会信用代码',
  获取客户协作权限失败: '获取客户协作权限失败',
  下次跟进时间为必填项: '下次跟进时间为必填项',
  请填写联系人所在部门: '请填写联系人所在部门',
  动态记录数据获取失败: '动态记录数据获取失败',
  '确认删除此节点？': '确认删除此节点？',
  '暂无日程，可新建日程': '暂无日程，可新建日程',
  '确认移除该日程？': '确认移除该日程？',
  '上传失败,请上传支持的文件类型': '上传失败,请上传支持的文件类型',
  '文件已存在，无需重复上传': '文件已存在，无需重复上传',
  '上传失败,文件大小不能超过50M': '上传失败,文件大小不能超过50M',
  请选择跟进方式: '请选择跟进方式',
  '请选择人员，仅支持选择租户内人员': '请选择人员，仅支持选择租户内人员',
  跟进时间是必填项: '跟进时间是必填项',
  跟进方式是必选项: '跟进方式是必选项',
  '输入人员名称，如有多人以，分割': '输入人员名称，如有多人以，分割',
  请填写会议妙记链接: '请填写会议妙记链接',
  下次跟进方式是必选项: '下次跟进方式是必选项',
  请选择下次跟进方式: '请选择下次跟进方式',
  请选择权限: '请选择权限',
  只能选择一个接收人: '只能选择一个接收人',
  退回原因: '退回原因',
  请填写转移原因: '请填写转移原因',
  接收线索池: '接收线索池',
  请选择接收线索池: '请选择接收线索池',
  请填写退回原因: '请填写退回原因',
  变更其他负责人: '变更其他负责人',
  请选择变更其他负责人: '请选择变更其他负责人',
  员工个人手机号: '员工个人手机号',
  请选择对接产品线: '请选择对接产品线',
  请选择对接人角色: '请选择对接人角色',
  请选择对接人职位: '请选择对接人职位',
  请选择所在部门: '请选择所在部门',
  请选择对接人态度: '请选择对接人态度',
  请填写补充信息: '请填写补充信息',
  请选择日期: '请选择日期',
  通话状态: '通话状态',
  请选择通话时长: '请选择通话时长',
  请选择客户规模: '请选择客户规模',
  行业: '行业',
  请选择行业: '请选择行业',
  日程状态: '日程状态',
  请选择日程状态: '请选择日程状态',
  日程未开始: '日程未开始',
  日程进行中: '日程进行中',
  日程已结束: '日程已结束',
  全量线索: '全量线索',
  建议转化线索: '建议转化线索',
  有效线索数: '有效线索数',
  线索跟进率: '线索跟进率',
  请选择通话状态: '请选择通话状态',
  的通话详情: '的通话详情',
  的日程详情: '的日程详情',
  请选择状态: '请选择状态',
  线下拜访: '线下拜访',
  线上: '线上',
  无: '无',
  通话总数: '通话总数', //*-
  对象Id不能为空: '对象Id不能为空',
  选择关联: '选择关联',
  审批中: '审批中',
  请输入名称: '请输入名称',
  '请选择/输入值搜索': '请选择/输入值搜索',
  报价单产品: '报价单产品',
  合同: '合同',
  合同产品: '合同产品',
  订单: '订单',
  订单产品: '订单产品',
  售后: '售后',
  请选择部门或人员: '请选择部门或人员',
  开始时间: '开始时间',
  下级: '下级',
  火山设置: '火山设置',
  应用凭证: '应用凭证',
  开发文档: '开发文档',
  '0~1分钟': '0~1分钟',
  '1~5分钟': '1~5分钟',
  '5~20分钟': '5~20分钟',
  '20~30分钟': '20~30分钟',
  '30分钟以上': '30分钟以上',
  首电沟通: '首电沟通',
  电话沟通: '电话沟通',
  '飞书/微信沟通': '飞书/微信沟通',
  线上Pitch: '线上Pitch',
  走进字节: '走进字节',
  正式会议: '正式会议',
  '外部活动/会议': '外部活动/会议',
  '喝茶/喝咖啡': '喝茶/喝咖啡',
  饭局: '饭局',
  来华映参访: '来华映参访',
  去对方拜访: '去对方拜访',
  '线上会议/电话/微信': '线上会议/电话/微信',
  '外部情报（未直接与对方联系）': '外部情报（未直接与对方联系）',
  等于: '等于',
  不等于: '不等于',
  包含: '包含',
  不包含: '不包含',
  为空: '为空',
  不为空: '不为空',
  单行文本: '单行文本',
  多行文本: '多行文本',
  单选按钮: '单选按钮',
  多选按钮: '多选按钮',
  下拉单选: '下拉单选',
  下拉多选: '下拉多选',
  数字: '数字',
  日期: '日期',
  日期范围: '日期范围',
  超链接: '超链接',
  查找关联: '查找关联(单选)',
  '查找关联(多选)': '查找关联(多选)',
  自增编码: '自增编码',
  金额: '金额',
  附件: '附件',
  部门: '部门',
  明细: '明细',
  教师: '教师',
  学生: '学生',
  设计负责人: '设计负责人',
  工程师: '工程师',
  '法人/CEO/老板': '法人/CEO/老板',
  总经理: '总经理',
  运营主管: '运营主管',
  IT主管: 'IT主管',
  技术负责人: '技术负责人',
  市场主管: '市场主管',
  首席数据官: '首席数据官',
  财务主管: '财务主管',
  '副总裁/高级副总裁': '副总裁/高级副总裁',
  '总监/高级总监': '总监/高级总监',
  '经理/高级经理': '经理/高级经理',
  普通员工: '普通员工',
  人事负责人: '人事负责人',
  销售主管: '销售主管',
  行政主管: '行政主管',
  业务主管: '业务主管',
  产品负责人: '产品负责人',
  董事长: '董事长',
  投资总监: '投资总监',
  投资经理: '投资经理',
  秘书: '秘书',
  其他管理层岗位: '其他管理层岗位',
  其他执行层岗位: '其他执行层岗位',
  咨询顾问: '咨询顾问',
  商务: '商务',
  售前: '售前',
  '意向沟通(20%)': '意向沟通(20%)',
  '商机确认(20%)': '商机确认(20%)',
  '方案沟通(30%)': '方案沟通(30%)',
  '商务谈判(20%)': '商务谈判(20%)',
  '客户签约(10%)': '客户签约(10%)',
  注册地址: '注册地址',
  办公地址: '办公地址',
  仓储地址: '仓储地址',
  门店地址: '门店地址',
  家庭地址: '家庭地址',
  单位: '单位',
  '编辑/删除联系人': '编辑/删除联系人',
  附件内容: '附件内容',
  请选择附件内容: '请选择附件内容',
  所在城市: '所在城市',
  请选择所在城市: '请选择所在城市',
  个人重要性: '个人重要性',
  请选择个人重要性: '请选择个人重要性',
  微信号: '微信号',
  请填写微信号: '请填写微信号',
  邮箱: '邮箱',
  请填写邮箱: '请填写邮箱',
  详细地址: '详细地址',
  请填写详细地址: '请填写详细地址',
  个人简介: '个人简介',
  请填写个人简介: '请填写个人简介',
  非常重要: '非常重要',
  较重要: '较重要',
  一般: '一般',
  未知: '未知',
  添加其他协作人: '添加其他协作人',
  拨打时长: '拨打时长',
  通话已接通: '通话已接通',
  通话未接通: '通话未接通',
  加入群组: '加入群组',
  审批中的退货单不可转移: '审批中的退货单不可转移',
  审批中的退货单不可作废: '审批中的退货单不可作废',
  '系统开小差了，请过后重试': '系统开小差了，请过后重试！',
  '文件上传未完成,请重新上传': '文件上传未完成,请重新上传!',
  '该名称已存在，当前无负责人': '该名称已存在，当前无负责人',
  '该名称已存在，当前负责人为': '该名称已存在，当前负责人为',
  我方参会人是必选项: '我方参会人是必选项',
  客户参会人是必选项: '客户参会人是必选项',
  请填写备注: '请填写备注',
  备注: '备注',
  设置原负责人为协作人: '设置原负责人为协作人',
  文档: '文档',
  计算公式: '计算公式',
  图片: '图片',
  图片V2: '图片V2',
  地址: '地址',
  职位: '职位',
  暂无查看权限: '暂无查看权限',
  复制链接: '复制链接',
  链接已复制到剪贴板: '链接已复制到剪贴板',
  复制失败: '复制失败',
  多维表格在当前页面环境无法正常登录: '多维表格在当前页面环境无法正常登录',
  点击按钮前往查看: '点击按钮前往查看',
  查看: '查看',
  没有找到匹配的数据: '没有找到匹配的数据',
  最多上传: '最多上传',
  列表新功能引导: '列表新功能引导',
  点击进行预览: '点击进行预览',
  列表数据模糊搜索: '列表数据模糊搜索',
  '列表需支持全量数据模糊搜索及指定字段类型的模糊搜索，以满足不同场景下的数据查询需求。': '列表需支持全量数据模糊搜索及指定字段类型的模糊搜索，以满足不同场景下的数据查询需求。',
  双击进入快捷编辑: '双击进入快捷编辑',
  '需实现双击列表对应数据单元格直接进入编辑状态的功能，支持在列表内完成数据维护。': '需实现双击列表对应数据单元格直接进入编辑状态的功能，支持在列表内完成数据维护。',
  操作列入口调整: '操作列入口调整',
  '操作列需取消右侧固定悬浮样式，调整为勾选数据后在屏幕下方显示操作入口，优化界面空间使用及操作体验。': '操作列需取消右侧固定悬浮样式，调整为勾选数据后在屏幕下方显示操作入口，优化界面空间使用及操作体验。',
  '当前登录账号身份已变更，请刷新后重试': '当前登录账号身份已变更，请刷新后重试',
  无符合条件的数据: '无符合条件的数据',
  '公式计算中，计算成功后触发后续操作': '公式计算中，计算成功后触发后续操作',
  审批处理中: '审批处理中',
  数据处理中: '数据处理中'
};
